import React, { useEffect, useState } from "react";
import { Toast as ToastComp, ToastContainer } from "react-bootstrap";
interface IToastProps {
  show: boolean;
  bg?: string;
  onClose?: () => void;
  title: string;
}
export default function CustomToast({ show, bg="success", onClose, title }: IToastProps) {
  const [showToast, setShowToast] = useState(show);
  useEffect(() => {
    setShowToast(show)
  }, [show]);
  return (
    <div className="row">
      <div className="col-12">
        <ToastContainer className="p-3" position="bottom-center">
          <ToastComp
            onClose={() => {
              if (onClose) {
                onClose();
              }
              setShowToast(false);
            }}
            bg={bg}
            show={showToast}
            delay={5000}
            autohide
          >
            <ToastComp.Header>
              <img
                src="holder.js/20x20?text=%20"
                className="rounded me-2"
                alt=""
              />
              <strong className="me-auto">{title}</strong>
              <small>Hace unos segundos</small>
            </ToastComp.Header>
            <ToastComp.Body className={"text-white"}>
              Registro actualizado exitosamente
            </ToastComp.Body>
          </ToastComp>
        </ToastContainer>
      </div>
    </div>
  );
}
